export const SHADERS = {
    loaded: {}
};
